
import React from 'react'
import { Card, Button, Space } from 'antd'
import { DeleteOutlined, DragOutlined } from '@ant-design/icons'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { LAYOUT_REGISTRY } from '../layouts/layoutRegistry'

const SortableCard = ({ item, onDelete, onFormChange, formData, setRef }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: item.id })
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }
  const LayoutComponent = LAYOUT_REGISTRY[item.layoutId]
  return (
    <div
      ref={(el) => {
        setNodeRef(el)
        if (el) setRef(el) // ✅ defensive
      }}
      style={style}
      {...attributes}
    >
      <Card
        style={{ marginBottom: 12 }}
        title={
          <Space>
            <span {...listeners} style={{ cursor: 'grab' }}>
              <DragOutlined />
            </span>
            Layout {item.layoutId}
          </Space>
        }
        extra={
          <Button
            danger
            size="small"
            icon={<DeleteOutlined />}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={() => onDelete(item.id)}
          />
        }
      >
        {LayoutComponent ? (
          <LayoutComponent
            onChange={(values) => onFormChange(item.id, values)} // Pass handler to update parent form data
            initialData={formData} // Pass current form data for initialization
          />
        ) : (
          'Unknown layout'
        )}
      </Card>
    </div>
  )
}
export default SortableCard